import { DealJourneyNavigatorPages, defaultFormValues, SessionStorageConstants } from "../../../../constants";
import { DealDetailsFormValues, DealJourneyStoredData } from "../../../../models";
import { jsonReviver, safeSessionStorage } from "../../../../utils";
import { Toast } from "../../../../widget";
import { getEmptyDealSpecificData } from "../../utils/dealSpecificDataUtils";
import { DealSpecificData } from "./dealSpecificDataUtils";

export const getStoredState = (): DealJourneyStoredData => {
  const raw = safeSessionStorage.getItem(SessionStorageConstants.Deal_Journey_Data);
  if (!raw) {
    return {
      inProgressPage: DealJourneyNavigatorPages.DETAILS,
      formValues: defaultFormValues,
      dealSpecificData: getEmptyDealSpecificData(),
    };
  }

  try {
    const parsed = JSON.parse(raw, jsonReviver) as {
      inProgressPage?: DealJourneyNavigatorPages;
      formValues?: DealDetailsFormValues;
      dealSpecificData?: DealSpecificData;
    };

    return {
      inProgressPage: parsed.inProgressPage ?? DealJourneyNavigatorPages.DETAILS,
      formValues: { ...defaultFormValues, ...(parsed.formValues ?? {}) },
      dealSpecificData: parsed.dealSpecificData ?? getEmptyDealSpecificData(),
    };
  } catch {
    return {
      inProgressPage: DealJourneyNavigatorPages.DETAILS,
      formValues: defaultFormValues,
      dealSpecificData: getEmptyDealSpecificData(),
    };
  }
};

export const setStoredState = (formValues: DealDetailsFormValues, inProgressPage: DealJourneyNavigatorPages): void => {
  try {
    const existing = getStoredState();
    safeSessionStorage.setItem(
      SessionStorageConstants.Deal_Journey_Data,
      JSON.stringify({
        inProgressPage,
        formValues: { ...formValues },
        dealSpecificData: existing.dealSpecificData ?? getEmptyDealSpecificData(),
      })
    );
  } catch (err) {
    const message = err instanceof Error ? err.message : "An unknown error occurred while saving to local storage.";
    Toast.warn({ message });
  }
};

export const removeStoredState = (): void => {
  try {
    safeSessionStorage.removeItem(SessionStorageConstants.Deal_Journey_Data);
  } catch (err) {
    const message = err instanceof Error ? err.message : "An unknown error occurred while clearing local storage.";
    Toast.warn({ message });
  }
};
